var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row result-row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "h6",
          {
            staticClass:
              "mb-0 text-gray sticky-top bg-white px-4 py-2 column-divider-top column-divider-bottom result-header bold",
          },
          [_vm._v("\n      " + _vm._s(_vm.getTypeTitle(_vm.type)) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.noResults
          ? _c("empty-message")
          : _c(
              "ul",
              { staticClass: "list-group list-group-flush mb-2" },
              _vm._l(_vm.results, function (result, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "list-group-item activity-item py-1 bt-0",
                    class: { "bt-0": index === 0 },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "pr-0 img col-auto" },
                        [
                          _c(
                            "profile-avatar",
                            _vm._b(
                              {
                                staticClass:
                                  "img-fluid rounded-circle lg activity-avatar",
                                attrs: { "avatar-options": { inline: false } },
                              },
                              "profile-avatar",
                              Object.assign({}, result),
                              false
                            )
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col comment-section",
                          attrs: { id: result.id },
                        },
                        [
                          _c("h6", { staticClass: "activity-title mb-0" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-link p-0 text-primary text-left small",
                                attrs: { href: _vm.getAnchor(result) },
                                on: { click: _vm.closePopover },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.getAnchorText(result)) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("result-subtitle", { attrs: { result: result } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type === "clientProfiles" && result.labelColour !== ""
                        ? _c(
                            "div",
                            [
                              _c(
                                "badge",
                                {
                                  style:
                                    "font-size:0.6rem !important; background-color: " +
                                    result.labelColour +
                                    " !important",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(result.labelText) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "activity-options col-auto align-self-center",
                        },
                        [_c("result-badge", { attrs: { result: result } })],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type === "clientProfiles"
                        ? _c("div", { staticClass: "mx-4" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "" + result.id,
                                    expression: "`${result.id}`",
                                  },
                                ],
                              },
                              [_c("icon", { attrs: { name: "caret-down" } })],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.type === "clientProfiles"
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-collapse",
                              { attrs: { id: "" + result.id } },
                              [
                                _c(
                                  "profile-card",
                                  _vm._b(
                                    {},
                                    "profile-card",
                                    Object.assign({}, result, {
                                      rottingDaysThreshold: 0,
                                      isDisplayedInSearch: true,
                                    }),
                                    false
                                  )
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }